export default __webpack_public_path__ + "static/media/canonbigbottom.2c1f725e.png";